<div *ngIf="loaded" #themeWrapper class="theme-wrapper {{ themeClass }} {{ customOrDefaultClass }}">

  <app-header #header></app-header>

  <app-main #main [redirectToUser]=redirectToUser></app-main>

  <!-- <app-footer></app-footer> -->

</div>
